import React, { Component } from 'react';
import { Tabs , Tab } from 'react-bootstrap';
import withAuthorization from '../Session/withAuthorization';
import { compose } from 'recompose';
import firebase from 'firebase';
import Spinner from '../Spinner';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/forms.css';
import '../css/main.css';

const moment = require('moment');

class FormUpload extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            key: "register",
            formPath : '/register.json',
            formData : [],
            error : true,
            file : '',
            errorType : [],
            currentCount: 10,
            show : false
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);       
    }

    handleSelect(key) {
        this.setState({ key });
    }

    renderForm(){
        var self= this , form = {};
        if(this.state.key.length > 0){
          form = require('../../form'+this.state.formPath);
        }
        return(
          <form ref={(el) => this.myFormRef = el}>  
            <div style={{ padding : '20px' , alignContent : 'flex-start'}} className="row">
              {self.state.key.length > 0 ?  
                form.map(function(temp) {
                  return(
                    <div key = {temp.title} className="column" >
                      <label>{temp.title} {temp.required ? '*' : ''}</label>
                        { temp.type === 'dropdown' ?
                            <select name="Choose the Service type" ref={(input) => self[temp.name] = input} className="wrap-input100">
                                <option value="Female">Female</option>
                                <option value="Male">Male</option>
                                <option value="Others">Others</option>
                            </select>  : 
                            <input 
                                className="wrap-input100"
                                type={temp.type}
                                placeholder={temp.title}
                                name= {temp.title}
                                required = {temp.required}
                                maxLength = {temp.maxlength}
                                ref={(input) => self[temp.name] = input}
                                style={{border : '1px'}}> 
                            </input> 
                        }
                    </div>
                  )
                }) : null
              }
              {self.state.key === 'others' ? 
                <div  className="column">
                    <label>Choose the Service type</label>
                    <select name="Choose the Service type" ref={input => {this.option = input}} className="wrap-input100">
                        <option value="Insurance">Insurance</option>
                        <option value="Medical Services">Medical Services</option>
                        <option value="Medical Shops">Medical Shops</option>
                        <option value="Fertilizers">Fertilizers</option>
                        <option value="Provision & Groceries Shops.">Provision & Groceries Shops.</option>
                        <option value="Hardware Shops">Hardware Shops</option>
                        <option value="Gold and Jewellery Shop">Gold and Jewellery Shop</option>
                        <option value="Readymade Garment Shop">Readymade Garment Shop</option>
                        <option value="Human Resources">Human Resources</option>
                    </select> 
                </div>
                : null }
                </div>

                {this.state.error ? <span className="error">Please input all the mandatory fields</span> : null}
                <div className="modal_button_align">
                    <button className="container-login100" type="submit" onClick={(event) => this.handleSubmit(event)}>Submit</button>
                </div>
            </form>
        )
    }
    
    handleSubmit(event){
        var self= this , form = {},  data = {} , errorType = [] , url = [];
        var uid = firebase.auth().currentUser.uid;
        form = require('../../form'+this.state.formPath);
        event.preventDefault();
        Object.keys(form).map(key=>{
            data[form[key].title] = self[form[key].name].value;
            if(self[form[key].name].required && self[form[key].name].value === '' ){
                errorType.push(form[key].title);
            }
        })
        if(errorType.length > 0){
            alert("Please input all the required fields !!");
        }
        else{
            var temp = this.file.files , res ;
            data["Type"] = self.state.key ;
            this.setState({
                show : true
            })
            if(temp.length > 0){
                var uid = firebase.auth().currentUser.uid ;
                var te = moment().format('x');
                var fileRef = firebase.storage().ref().child(uid).child('images').child(te+temp[0].name);
        
                var task = fileRef.put(temp[0]).then(snapshot => {
                    snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        data['Upload Document'] =  downloadURL;
                        firebase.database().ref('users/vendors').child(uid).child('users').push(data , function(error){
                            if(error){
                                alert(error);
                                return;
                            }
                            alert("Upload successfull.")
                            self.setState({
                                error : false,
                                show : false
                            }) 
                            self.myFormRef.reset();
                        });
                    });
                })
               
            }
            else{
                firebase.database().ref('users/vendors').child(uid).child('users').push(data , function(error){
                    if(error){
                        alert(error);
                        return;
                    }
                    alert("Upload successfull.")
                    self.setState({
                        error : false,
                        show : false
                    }) 
                    self.myFormRef.reset();
                });
            }
        }
    }

    uploadImageAsPromise (imageFile, url , self , data) {
        const promises = [];
        return new Promise(function (resolve, reject) {
            var uid = firebase.auth().currentUser.uid ;
            var te = moment().format('x');
            var fileRef = firebase.storage().ref().child(uid).child('images').child(te+imageFile.name);
    
            var task = fileRef.put(imageFile);
            promises.push(task);
            task.on('state_changed', function(snapshot){
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused');
                    break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running');
                    break;
                }
            }, 
            function() {
                task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    url.push(downloadURL);
                    data["Upload Document"] = url;
                    firebase.database().ref('users/vendors').child(uid).child('users').push(data , function(error){
                        if(error){
                            alert(error);
                            return;
                        }
                        alert("Upload successfull.")
                        self.setState({
                            error : false
                        }) 
                        self.myFormRef.reset();
                    });
                })
            })
        })
    }

    render(){
        const data = require('../../form/buttons.json');
        return(
            <div className="display_home">
                {this.state.show ? <Spinner /> : null}
                <span className="welcome_user">Upload Users For Sri Universal Suraksha Card</span>
                <Tabs
                    activeKey={this.state.key}
                    onSelect={this.handleSelect}
                    animation
                    ref={(el) => this.activeTab = el} 
                    className = {this.state.key  ? 'limiter' : null}>
                    {
                        Object.keys(data).map(key => 
                            <Tab eventKey={data[key].type} title={data[key].name} key={data[key].type} 
                                style={{width : '100%'}}>
                                {this.state.key === data[key].type ? this.renderForm() : null}
                            </Tab>
                        )
                    }
                </Tabs>
            </div>
        )
    }
}

const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition))(FormUpload);